import { COLOR_OPTIONS } from 'config/style';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const getContainerBackgroundColor = (riskLevel?: RiskLevelEnum): string => {
  if (riskLevel === undefined) {
    return COLOR_OPTIONS.NEUTRAL_10;
  }

  switch (riskLevel) {
    case RiskLevelEnum.HIGH:
      return COLOR_OPTIONS.RED_20;
    case RiskLevelEnum.MEDIUM:
      return COLOR_OPTIONS.YELLOW_20;
    case RiskLevelEnum.LOW:
      return COLOR_OPTIONS.GREEN_20;
    case RiskLevelEnum.NO_RISK:
    default:
      return COLOR_OPTIONS.NEUTRAL_10;
  }
};

export const getIconColor = (riskLevel?: RiskLevelEnum): string => {
  if (riskLevel === undefined) {
    return COLOR_OPTIONS.NEUTRAL_60;
  }

  switch (riskLevel) {
    case RiskLevelEnum.HIGH:
      return COLOR_OPTIONS.RED_60;
    case RiskLevelEnum.MEDIUM:
      return COLOR_OPTIONS.YELLOW_50;
    case RiskLevelEnum.LOW:
      return COLOR_OPTIONS.GREEN_40;
    case RiskLevelEnum.NO_RISK:
      return COLOR_OPTIONS.GREEN_60;
    default:
      return COLOR_OPTIONS.NEUTRAL_60;
  }
};

export type IconType = 'warning' | 'check' | 'question';

export const getIconType = (riskLevel?: RiskLevelEnum): IconType => {
  if (riskLevel === undefined) {
    return 'question';
  }

  switch (riskLevel) {
    case RiskLevelEnum.HIGH:
    case RiskLevelEnum.MEDIUM:
    case RiskLevelEnum.LOW:
      return 'warning';
    case RiskLevelEnum.NO_RISK:
      return 'check';
    default:
      return 'question';
  }
};

export const getRiskLevelTranslationKey = (riskLevel?: RiskLevelEnum): string => {
  if (riskLevel === undefined) {
    return 'regional_overview.regional_risk.overview.missing_data';
  }

  switch (riskLevel) {
    case RiskLevelEnum.HIGH:
      return 'regional_overview.regional_risk.overview.high_risk';
    case RiskLevelEnum.MEDIUM:
      return 'regional_overview.regional_risk.overview.medium_risk';
    case RiskLevelEnum.LOW:
      return 'regional_overview.regional_risk.overview.low_risk';
    case RiskLevelEnum.NO_RISK:
      return 'regional_overview.regional_risk.overview.no_risk';
    default:
      return 'regional_overview.regional_risk.overview.missing_data';
  }
};
